import type { BlockSpec } from '@blocksuite/block-std';
import {
  BookmarkBlockSpec,
  CodeBlockSpec,
  DatabaseBlockSpec,
  DataViewBlockSpec,
  DividerBlockSpec,
  EmbedFigmaBlockSpec,
  EmbedGithubBlockSpec,
  EmbedHtmlBlockSpec,
  EmbedLinkedDocBlockSpec,
  EmbedLoomBlockSpec,
  EmbedSyncedDocBlockSpec,
  EmbedYoutubeBlockSpec,
  ListBlockSpec,
  NoteBlockSpec,
} from '@blocksuite/blocks';
import { AIChatBlockSpec, EdgelessAIChatBlockSpec } from '@blocksuite/presets';
import {
  AIImageBlockSpec,
  AIParagraphBlockSpec,
} from '@pique/core/blocksuite/presets/ai';
import { PiqueDatabaseBlockSpec } from '@pique/core/blocksuite/presets/database/pique-database-spec';

import { CustomAttachmentBlockSpec } from './custom/attachment-block';
import { EdgelessElementGroupsBlockSpec } from './custom/pique/edgeless-group/edgeless-group-model';
import { PiqueHtmlEmbedBlockSpec } from './custom/pique/html/html-embed-block';
import { PiqueLatexBlockSpec } from './custom/pique/latex/latex-block';
import { PiqueMermaidBlockSpec } from './custom/pique/mermaid/mermaid-block';
import { PiqueQuizEmbedBlockSpec } from './custom/pique/quiz/quiz-embed-block';
import { PiqueYoutubeEmbedBlockSpec } from './custom/pique/youtube/youtube-embed-block';
export const CommonBlockSpecs: BlockSpec[] = [
  ListBlockSpec,
  NoteBlockSpec,
  CodeBlockSpec,
  DatabaseBlockSpec,
  DataViewBlockSpec,
  DividerBlockSpec,
  BookmarkBlockSpec,
  EmbedFigmaBlockSpec,
  EmbedGithubBlockSpec,
  EmbedYoutubeBlockSpec,
  EmbedLoomBlockSpec,
  EmbedHtmlBlockSpec,
  EmbedSyncedDocBlockSpec,
  EmbedLinkedDocBlockSpec,
  // special
  CustomAttachmentBlockSpec,
  AIImageBlockSpec,
  AIParagraphBlockSpec,
  AIChatBlockSpec,
  EdgelessAIChatBlockSpec,
  // pique
  PiqueYoutubeEmbedBlockSpec,
  PiqueHtmlEmbedBlockSpec,
  PiqueQuizEmbedBlockSpec,
  PiqueDatabaseBlockSpec,
  EdgelessElementGroupsBlockSpec,
  PiqueLatexBlockSpec,
  PiqueMermaidBlockSpec,
];
